import * as React from 'react'

import { Input } from '../../../../../Shared'

interface TitleFieldProps {
  clearSlide: Function,
  resetSlide: Function,
  handleTitleChange: any,
  questionIndex: number,
  title: string
}

const TitleField: React.SFC<TitleFieldProps> = ({ questionIndex, clearSlide, resetSlide, handleTitleChange, title, }: TitleFieldProps) => {
  const inputId = `title-${questionIndex}`

  return (
    <div className="title-field field">
      <div className="spread-label">
        <label htmlFor={inputId}>Title</label>
        <div className="options">
          <button className="quill-button extra-small outlined red focus-on-light clear-slide" onClick={() => clearSlide(questionIndex)} type="button">Clear slide</button>
          <button className="quill-button extra-small outlined red focus-on-light reset-slide" onClick={() => resetSlide(questionIndex)} type="button">Reset slide</button>
        </div>
      </div>
      <Input
        className="bordered large"
        handleChange={handleTitleChange}
        id={inputId}
        value={title}
      />
    </div>
  )
}

export default TitleField
